<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Service</p>
      </header>

      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-6">
            <o-field label="Name" :type="fieldType('title')" :message="getError('title')">
              <o-input v-model="copy.title" />
            </o-field>
          </div>
          <div class="column is-6">
            <o-field label="Price" :type="fieldType('price')" :message="getError('price')">
              <o-input v-model="copy.price" />
            </o-field>
          </div>
        </div>
        <div class="block">
          <o-checkbox v-model="copy.is_initial">Initial</o-checkbox>
          <o-checkbox v-model="copy.is_optional" >Optional</o-checkbox>
          <o-checkbox v-model="copy.is_active">
            {{ copy.is_active ? 'Active' : 'Inactive' }}
          </o-checkbox>
          <o-checkbox v-model="copy.reimbursable">Reimbursable</o-checkbox>
        </div>
        <o-tabs >
          <o-tab-item label="Notes">
            <o-field :type="fieldType('description')" :message="getError('description')">
              <quill-editor :content="copy.description" @update:content="copy.description = $event" :options="editorToolbar" :content-type="'html'" />
            </o-field>
          </o-tab-item>
          <o-tab-item :disabled="!copy.is_initial" label="Work Types">
            <div class="block">
              <o-field label="Work Type Price" :type="fieldType('subservice_price')" :message="getError('subservice_price')">
                <o-input v-model="copy.subservice_price" />
              </o-field>

              <label class="label">Work Types</label>

              <o-checkbox v-for="wt in serviceWorkTypes"
                          :custom-value="wt.id"
                          :key="wt.id"
                          v-model="copy.work_types"
                          :native-value="wt.id"
              >
                {{ wt.title }}
              </o-checkbox>
            </div>
          </o-tab-item>
          <o-tab-item label="Todo Preset">
            <checklist v-model="checklistItems"></checklist>
          </o-tab-item>
        </o-tabs >





      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
      </footer>
    </div>
  </form>
</template>

<style>
.block label.checkbox {
  margin-right: 0;
  margin-left: 0.5em; }

.checkboxitem .o-checkbox.checkbox[disabled] {
  opacity: 1;
  color: #000; }
.checkboxitem .o-checkbox.checkbox[disabled] .control-label {
  color: #000; }

</style>

<script>
import { QuillEditor } from "@vueup/vue-quill";
import { mapActions, mapGetters } from 'vuex';
import Checklist from '../Checklist';
import HandlesForm from './../../mixins/HandlesForm';

export default {
  mixins: [HandlesForm],

  components: {
    QuillEditor,
    Checklist
  },
  data() {
    return {
      copy: {
        title: null,
        is_initial: false,
        is_optional: false,
        price: null,
        description: null,
        is_active: null,
        reimbursable: false,
        subservice_price: null,
        work_types: [],
        todo_template: []
      }
    }
  },

  computed: {
    ...mapGetters(['serviceWorkTypes', 'editorToolbar']),
    checklistItems: {
      get: function() {
        return _.map(this.copy.todo_template, p => { return { description: p } })
      },
      set: function(newValue) {
        this.copy.todo_template = _.map(newValue, p => p.description)
      }
    }
  },

  methods: {
    ...mapActions(['createOrUpdateService']),

    handleSubmit() {
      let submit = this.wrapSubmit(this.createOrUpdateService)

      submit(this.copy)
          .then(res => {
            this.successMessage('Service has been successfull created')
            this.$parent.$parent.$emit('update:active', false)
            this.$parent.$parent.close()
            return res
          })
    }
  }
}
</script>
<style>
.modal-card-body {
  overflow: auto;
  background-color: #fafafa; }
.modal-card-body .tab-content {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc; }
</style>